import React from "react";
import IconBase from "./IconBase";

const LineChart = (props: any) => {
  return (
    <IconBase viewBox="0 0 32 32" {...props}>
      <path d="M31.875 4.063L20.937 15.001l-7-6.938-9.938 9.938v6l9.938-10 7 7 10.938-11zM4 27.938V.063H0v31.875h32v-4z" />
    </IconBase>
  );
};

export default LineChart;
